import styled from '@emotion/styled'

export const error = {
    color: '#d32f2f',
    marginLeft: 2,
}

export const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
export const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

export const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

export const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
export const TotalSum = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`
export const TotalInfoBox = styled.div`
    font-size: 18px;
    color: #404a51;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 24px;
    background: #f1f3f5;
    border: 1px solid #f1f3f5;
    border-radius: 8px;
`
export const TotalInfoText = styled.p`
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
`
export const DateWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`
export const ComponentsWrapper = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
`

export const FilterBox = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
` 

export const SearchStyles = {
    boxContainer: {
        margin: '10px',
        borderRadius: '16px',
    },
    filterBox: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 2,
    },
    searchBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    },
    search: {
        width: '440px',
    },
}
